export const useConversions = () => {
  const toRadians = (degrees) => {
    return degrees * (Math.PI / 180);
  };

  const average = (arr) => {
    if (arr.length === 0) return 0;
    const sum = arr.reduce((acc, val) => acc + val, 0);
    return parseFloat((sum / arr.length).toFixed(2));
  };

  const toPascalCase = (str) => {
    const camelCaseStr = str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    return camelCaseStr.charAt(0).toUpperCase() + camelCaseStr.slice(1);
  };

  return {
    toRadians,
    average,
    toPascalCase,
  };
};
